import { render, staticRenderFns } from "./ReportarFacturas.vue?vue&type=template&id=673df6b8&"
import script from "./ReportarFacturas.vue?vue&type=script&lang=js&"
export * from "./ReportarFacturas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports